import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { toast_config } from "../../utils/constants";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const ShowAllCategories = createAsyncThunk(
  "ShowAllCategories",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/show-Categories`,
        arg
      );
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const CountAllCategories = createAsyncThunk(
  "CountAllCategories",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/count-Categories`,
        arg
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const AddCategories = createAsyncThunk(
  "AddCategories",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/add-Categories`,
        arg
      );
      toast.success("Category added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const disableCategorie = createAsyncThunk(
  "disableCategorie",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/disable-Categories`,
        { id }
      );
      toast.success("Category disabled successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const enableCategorie = createAsyncThunk(
  "enableCategorie",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/enable-Categories`,
        { id }
      );
      toast.success("Category enabled successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const deleteCategorie = createAsyncThunk(
  "deleteCategorie",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/v1/VendorManagement/delete-Categories`,
        { data: { id } }
      );
      toast.success("Category deleted successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllServiceLocation = createAsyncThunk(
  "ShowAllServiceLocation",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/show-AllLocations`,
        arg
      );
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllPopularLocation = createAsyncThunk(
  "ShowAllServiceLocation",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/show-PopularLocation`,
        arg
      );
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const AddServiceLocation = createAsyncThunk(
  "AddServiceLocation",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/add-ServiceLocation`,
        arg
      );
      toast.success("Service location added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);
export const AddPopularLocation = createAsyncThunk(
  "AddPopularLocation",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/add-PopularLocation`,
        arg
      );
      toast.success("Popular location added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);





export const disableServiceLocation = createAsyncThunk(
  "disableServiceLocation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/disable-ServiceLocation`,
        { id }
      );
      toast.success("Service location disabled successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const enableServiceLocation = createAsyncThunk(
  "enableServiceLocation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/enable-ServiceLocation`,
        { id }
      );
      toast.success("Service location enabled successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const deleteServiceLocation = createAsyncThunk(
  "deleteServiceLocation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/v1/VendorManagement/delete-ServiceLocation`,
        { data: { id } }
      );
      toast.success("Service location deleted successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const AddVendorDetails = createAsyncThunk(
  "AddVendorDetails",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/Add-VendorDetails`,
        arg,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Vendor details added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowOneVendorDetail = createAsyncThunk(
  "ShowOneVendorDetail",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/show-ShowOneVendorDetail/${ID}`
      );
      console.log("---->", response);
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

const VendorManagementSlice = createSlice({
  name: "VendorManagementSlice",
  initialState: {
    AllCategories: 0,
    AllData: [],
    AllCat: [],
    AllLoc: [],
    Vendordetail: [],
    IsAdding: false,
    loading: false,
    error: null,
  },
  reducers: {
    IsAddingOpen: (state) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // CountAllCategories reducers
      .addCase(CountAllCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(CountAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.AllCategories = action.payload.CountCategories;
      })
      .addCase(CountAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // ShowAllCategories reducers
      .addCase(ShowAllCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.AllCat = action.payload.ShowAllCategorie;
      })
      .addCase(ShowAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // AddCategories reducers
      .addCase(AddCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddCategories.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(AddCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // disableCategorie reducers
      .addCase(disableCategorie.pending, (state) => {
        state.loading = true;
      })
      .addCase(disableCategorie.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(disableCategorie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // enableCategorie reducers
      .addCase(enableCategorie.pending, (state) => {
        state.loading = true;
      })
      .addCase(enableCategorie.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(enableCategorie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // deleteCategorie reducers
      .addCase(deleteCategorie.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCategorie.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(deleteCategorie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // ShowAllServiceLocation reducers
      .addCase(ShowAllServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.AllLoc = action.payload.ShowAllLocations;
      })
      .addCase(ShowAllServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // AddServiceLocation reducers
      .addCase(AddServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(AddServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })
      // Update ServiceLocations
      .addCase(AddPopularLocation.pending, (state) => {
        state.loading = true; // Use the same 'loading' as other cases
      })
      .addCase(AddPopularLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.isSuccess = true;

        // Update the location in the state if needed
        const index = state.AllLoc.findIndex(
          (loc) => loc.id === action.payload.id
        );
        if (index !== -1) {
          state.AllLoc[index] = action.payload; // Replace with updated data
        }
      })
      .addCase(AddPopularLocation.rejected, (state, action) => {
        state.loading = false;
        state.isSuccess = false;
        state.error = action.payload;
      })

      // disableServiceLocation reducers
      .addCase(disableServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(disableServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(disableServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // enableServiceLocation reducers
      .addCase(enableServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(enableServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(enableServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // deleteServiceLocation reducers
      .addCase(deleteServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(deleteServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // AddVendorDetails reducers
      .addCase(AddVendorDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddVendorDetails.fulfilled, (state, action) => {
        state.loading = false;
        // Update state if needed upon successful completion
      })
      .addCase(AddVendorDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      })

      // ShowOneVendorDetail reducers
      .addCase(ShowOneVendorDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowOneVendorDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.Vendordetail = action.payload.Vendordetail;
      })
      .addCase(ShowOneVendorDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // or handle error as per your requirement
      });
  },
});

export const { IsAddingOpen, IsAddingClose } = VendorManagementSlice.actions;
export default VendorManagementSlice.reducer;
